
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31.359 41.207"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.947 0v30.805l-9.11-9.114-.353.354-3.486 3.484L15.68 41.207l15.68-15.678-3.839-3.838-9.107 9.112V0zm1 1h3.467v32.217l10.107-10.112 2.424 2.424L15.68 39.793 1.412 25.529l2.426-2.424 10.11 10.114z"}})])
          )
        }
      }
    